class CarouselNode {
    content
    next
    previous

    constructor(content) {
        this.content = content;
        this.next = null;
        this.previous = null;
    }
}


class Carousel {
    // add is based on queue (head->tail) not queue (tail->head), so add your first elements in first
    #head
    #current
    #tail
    #totalNodes
    #direction

    constructor(direction = "queue") {
        this.#head = null;
        this.#current = null;
        this.#tail = null;
        this.#totalNodes = 0;
        this.#direction = direction;
    }

    add(content) {
        try {
            this.#totalNodes++;
            const node = new CarouselNode({content: content, position: this.#totalNodes, current: false});
            // nothing in list yet
            if(!this.#head || !this.#current || !this.#tail){
                this.#head = this.#current = this.#tail = node;
                this.#current.content = {...this.#current.content, current: true};
                node.next = this.#tail;
                node.previous = this.#head;
            }
            else{
                if(this.#direction === "queue"){
                    // move tail to new node
                    // this.#tail.content = {...this.#tail.content, current: false};
                    this.#tail.next = node;
                    node.previous = this.#tail;
                    node.next = this.#head;
                    this.#head.previous = node;
                    this.#tail = node;
                    // this.#current = node;
                    // this.#current.content = {...this.#current.content, current: true};
                }else {
                    // move head to new node
                    this.#head.content = {...this.#head.content, current: false};
                    this.#head.next = node;
                    node.previous = this.#head;
                    node.next = this.#tail;
                    this.#tail.previous = node;
                    this.#head = node;
                    this.#current = node;
                    this.#current.content = {...this.#current.content, current: true};
                }
            }
        } catch (error) {
            this.#totalNodes--;
        }
    }

    next() {
        // move to the next item in the stack, i.e. if at head already then next is tail
        
        this.#current.content = {...this.#current.content, current: false};
        this.#current = this.#current.next;
        this.#current.content = {...this.#current.content, current: true};
    }

    previous() {
        // move to previous item in the stack, i.e. if at tail already then head is next
        this.#current.content = {...this.#current.content, current: false};
        this.#current = this.#current.previous;
        this.#current.content = {...this.#current.content, current: true};
    }

    // finds the most effective direction to traverse the stack
    #diffFinder(number1, number2) {
        let value1 = false;
        let value2 = Math.abs(number1 - number2)
        let value3 = false;

        if(number1 > number2){
            value1 = true;
        }

        if(value2 > Math.ceil(this.#totalNodes/2)){
            value2 = this.#totalNodes-value2;
            value3 = true;
        }

        return [value1, value2, value3];
    }

    // mass shifts right n number of times to seek a position 
    #shiftRight(tempCurrent, positions) {
        for (let i = 1; i <= positions; i++) {
            tempCurrent = tempCurrent.next;
        }

        this.#current = tempCurrent;
        this.#current.content = {...this.#current.content, current: true};
    }

    // mass shifts left n number of times to seek a position 
    #shiftLeft(tempCurrent, positions) {
        for (let i = 1; i <= positions; i++) {
            tempCurrent = tempCurrent.previous;
        }
        this.#current = tempCurrent;
        
        this.#current.content = {...this.#current.content, current: true};
    }

    // seeks out position of item in stack
    shiftTo(targetPosition) {
        if(targetPosition === this.#current.content.position){
            return;
        }        

        this.#current.content = {...this.#current.content, current: false};
        let tempCurrent = this.#current;

        const [greater, targetIndex, inverse] = this.#diffFinder(targetPosition, this.#current.content.position);

        if(greater){
            if(inverse){
                this.#shiftLeft(tempCurrent, targetIndex);
            }
            else{
                this.#shiftRight(tempCurrent, targetIndex);
            }
        }
        else {
            if(inverse){
                this.#shiftRight(tempCurrent, targetIndex);
            }
            else{
                this.#shiftLeft(tempCurrent, targetIndex);
            }
        }
    }

    getCarousel(setCarouselState, setCurrentCarouselState, centered) {
        let carouselArr = [];
        let tempCurr = this.#current;
        if(setCurrentCarouselState){
            setCurrentCarouselState(tempCurr.content);
        }

        if(centered) {
            tempCurr = this.#current;
            const actualTotalNodes = this.#totalNodes;
            // const actualTotalNodes = this.#totalNodes + 1;
            const isOdd = actualTotalNodes%2;
            let leftNodeCount = 0;
            let rightNodeCount = 0;

            if(!isOdd){
                leftNodeCount = rightNodeCount = actualTotalNodes/2;
            }else {
                leftNodeCount = Math.floor(actualTotalNodes/2);
                rightNodeCount = Math.ceil(actualTotalNodes/2);
            }
            
            // prep for left
            for (let index = 1; index <= leftNodeCount; index++) {
                // carouselArr.push(tempCurr.content);
                tempCurr = tempCurr.previous;
            }
            
            // left
            for (let index = 1; index <= leftNodeCount; index++) {
                carouselArr.push(tempCurr.content);
                tempCurr = tempCurr.next;
            }

            // carouselArr.push(tempCurr.content);
            
            // right
            for (let index = 1; index <= rightNodeCount; index++) {
                carouselArr.push(tempCurr.content);
                tempCurr = tempCurr.next;
            }
            // for (let index = 1; index <= rightNodeCount + 1; index++) {
            //     carouselArr.push(tempCurr.content);
            //     tempCurr = tempCurr.next;
            // }
        }
        else {
            if (this.#direction === "queue") {
                for (let index = 1; index <= this.#totalNodes; index++) {
                    carouselArr.push(tempCurr.content);
                    tempCurr = tempCurr.next;
                }                
            } else {
                tempCurr = this.#current.next;

                for (let index = 1; index <= this.#totalNodes; index++) {
                    carouselArr.push(tempCurr.content);
                    tempCurr = tempCurr.next;
                }
            }
        }

        // console.log("carousel array:");
        // console.log(carouselArr);
        
        
        setCarouselState(carouselArr);
    }

    empty(){
        let thead = this.#head;
        // console.log("empty: ");

        for (let i = 0; i < this.#totalNodes; i++) {
            if(i === this.#totalNodes-1){
                thead.previous.next = null;
                thead.previous = null;
                thead = null;
                // console.log(this.#head);
                
                // this.#current.next = null;
                // this.#head.next = null;
                // this.#tail.next = null;
                
                // this.#current.previous = null;
                // this.#head.previous = null;
                // this.#tail.previous = null;

                this.#current = null;
                this.#head = null;
                this.#tail = null;

                this.#totalNodes = 0;
            }
            else {
                // console.log(i);
                // console.log(thead);
                thead.previous.next = null;
                thead.previous = null;
                thead = thead.next;
            }
        }
    }
}

export default Carousel;